import React, { useState } from "react";
import { ChevronsUpDownIcon } from "lucide-react";

const MetrcisPnlTable = ({ rows }) => {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  const sortedRows = rows.slice().sort((a, b) => {
    const valA = a[sortColumn];
    const valB = b[sortColumn];
    if (valA < valB) {
      return sortOrder === "asc" ? -1 : 1;
    }
    if (valA > valB) {
      return sortOrder === "asc" ? 1 : -1;
    }
    return 0;
  });

  return (
    <div className="z-0  animate-reveal transition-all duration-500 ease-in">
      <table className="bg-black border border-gray-700 text-sm w-full relative z-0">
        <thead className="bg-[#0F0F0F] text-sm text-left">
          <tr className="text-white text-xs border-b border-gray-800 last-of-type:border-r-0">
            <th className=" border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className=" text-white/70 py-3 font-semibold">
                  Strategy
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("strategy")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            <th className=" border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className=" text-white/70 py-3 font-semibold">
                  Total PNL (₹)
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("totalPNL")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  Accuracy (%)
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("accuracy")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  Total Trades
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("totalTrades")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  (+ve) Trades
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("positiveTrades")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  (-ve) Trades
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("negativeTrades")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  Win Trades (₹)
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("winTradesRS")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  Loss Trades (₹)
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("lossTradesRS")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  Win Day Avg. Profit (₹)
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("avgProfitOnWinDays")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  Loss Day Avg. Loss (₹)
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("avgLossOnLossDays")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            {/* <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  Win Ratio
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("winRatio")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th> */}
            {/* <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  Loss Ratio
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("lossRatio")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th> */}
            <th className="border-r border-gray-800 px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  RR Ratio
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("rrRatio")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
            <th className="px-4">
              <div className="flex items-center">
                <span className="text-white/70 py-3 font-semibold">
                  Expectancy (₹)
                </span>
                <ChevronsUpDownIcon
                  onClick={() => handleSort("expectancy")}
                  className="ml-2 h-4 cursor-pointer w-4 text-white"
                />
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          {sortedRows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="bg-black z-0 border-b last-of-type:border-b-0 border-gray-900 text-right font-medium text-white hover:bg-black/90"
            >
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-left`}
              >
                {row.strategy}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900  ${
                  row.totalPNL > 0
                    ? "text-green-400"
                    : row.totalPNL < 0
                    ? "text-rose-500"
                    : "text-white"
                }`}
              >
                {row.totalPNL.toFixed(0)}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 ${
                  row.accuracy > 0 ? "text-green-400" : "text-white"
                } `}
              >
                {row.accuracy}%
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white `}
              >
                {row.totalTrades}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-green-400 `}
              >
                {row.positiveTrades}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-rose-500 `}
              >
                {row.negativeTrades}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-green-400 `}
              >
                {row.winTradesRS.toFixed(0)}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-rose-500`}
              >
                {row.lossTradesRS.toFixed(0)}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-green-400 `}
              >
                {row.avgProfitOnWinDays.toFixed(0)}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-rose-500 `}
              >
                {row.avgLossOnLossDays.toFixed(0)}
              </td>
              {/* <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-green-400 `}
              >
                {row.winRatio}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-rose-500 `}
              >
                {row.lossRatio}
              </td> */}

              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900  ${
                  row.rrRatio > 0
                    ? "text-green-400"
                    : row.rrRatio < 0
                    ? "text-rose-500"
                    : "text-white"
                }`}
              >
                {row.rrRatio}
              </td>
              <td
                className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 ${
                  row.expectancy > 0
                    ? "text-green-400"
                    : row.expectancy < 0
                    ? "text-rose-500"
                    : "text-white"
                }`}
              >
                {row.expectancy.toFixed(0)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MetrcisPnlTable;
